import { createFileRoute } from "@tanstack/react-router";
import { BarChart3Icon } from "lucide-react";
import { UsageDashboard } from "@/components/admin/usage/usage-dashboard";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/usage")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminUsagePage,
});

function AdminUsagePage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 font-medium text-muted-foreground text-xs uppercase tracking-wider">
          <BarChart3Icon className="size-3.5" />
          Operate
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading font-semibold text-3xl tracking-tight">Tool usage</h1>
          <p className="max-w-2xl text-muted-foreground text-sm">
            How your document tools are used across every workspace — built-in generator activity
            and success rates, plus an AI analysis of the custom tools your users build.
          </p>
        </div>
      </header>

      <UsageDashboard />
    </div>
  );
}
